import { useEffect } from 'react';

import { PermissionStatus } from 'expo-modules-core';
import { UNSET } from 'features/analytics/constants';
import { setAmplitudeOptOut } from 'features/analytics/providers/amplitude/client';
import { setAmplitudeUserAttributes } from 'features/analytics/utils';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { getAdDeviceId } from 'utils/device-id/get-ad-device-id';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';
import noop from 'utils/noop';

export const updateAmplitudeATTStatus = noop as (status: PermissionStatus) => void;

export const useAmplitudeOptOut = () => {
  const enableOptionalAmplitudeTracking = useFlag(
    LaunchDarklyFlag.ENABLE_OPTIONAL_AMPLITUDE_TRACKING
  );

  useEffect(() => {
    const cognitoId = syncStorage.getString(SyncStorageKey.USER_ID);

    // If we turn on optional Amplitude tracking
    // users will be able to opt out of Amplitude tracking.
    // If we decide that we do not want to disable events,
    // when we disable the flag (making Amplitude tracking not-optional),
    // we need to change setOptOut to false in order to send events to Amplitude.
    // This would guarantee any users who previously opted out, will be opted back in.
    // We should always faithfully record in local storage + Amplitude what the user wants us to do.
    // If we have good reason to not respect their preferences - that is where we should override their preferences.
    // REVISIT
    if (cognitoId && !enableOptionalAmplitudeTracking) {
      setAmplitudeOptOut(false);
    }
  }, [enableOptionalAmplitudeTracking]);
};

export const refreshAmplitudeAdvertisingId = async (): Promise<void> => {
  const adDeviceId = await getAdDeviceId();
  setAmplitudeUserAttributes({ deviceAdId: adDeviceId || ((UNSET as unknown) as string) });
};
